import { c as _c } from "react/compiler-runtime";
import { FullPageLoader } from '@/components/ui/FullPageLoader';
import { ClientProvider } from '@/context/ClientProvider';
import { SecurityLoadingProvider, useSecurityLoading } from '@/context/SecurityLoadingContext';
import { SubscriptionProvider } from '@/context/SubscriptionProvider';
import { BilyLifecycleReporter } from '@/hooks/useBilyLifecycleReporter';
import { TopBarProvider } from '@/context/TopBarContext';
import { UserRoleProvider } from '@/context/UserRoleProvider';
import { OrganizationGuard } from '@/guards/components/OrganizationGuard';
import { SubscriptionGuard } from '@/guards/components/SubscriptionGuard';
import { ReactNode } from 'react';
type SecurityProviderProps = {
  children: ReactNode;
};

/** Shows a single FullPageLoader while any guard/provider is still loading */
const SecurityLoadingOverlay = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    isAnyLoading
  } = useSecurityLoading();
  let t1;
  if ($[0] !== isAnyLoading) {
    t1 = isAnyLoading && <FullPageLoader />;
    $[0] = isAnyLoading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <>{t1}{children}</>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const SecurityProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BilyLifecycleReporter />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <SecurityLoadingProvider><SecurityLoadingOverlay><OrganizationGuard><ClientProvider><TopBarProvider><SubscriptionProvider>{t1}<UserRoleProvider><SubscriptionGuard>{children}</SubscriptionGuard></UserRoleProvider></SubscriptionProvider></TopBarProvider></ClientProvider></OrganizationGuard></SecurityLoadingOverlay></SecurityLoadingProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export { SecurityProvider };